import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#214B93',
    },
    secondary: {
      main: '#104EB2',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8FBFF'
    },
    text: {
      primary: '#000000',
      secondary: '#104EB2',
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: 'black'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#104EB2',
          color: '#FFFFFF',
        },
      }
    }
  }
});

export default theme;
